import React from 'react';
import PaymentQRCodeComponent from './payment-qr-code.component';

const PaymentQRCode = (props) => {
    return <PaymentQRCodeComponent {...props} />;
};

export default PaymentQRCode;
